import { BoxProps, Heading, Tag, TagText } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";

interface IStoryAwardsProps extends BoxProps {
  story: Pick<IStoryFieldsFragment, "awards">;
}

export default function StoryAwards({ story }: IStoryAwardsProps) {
  return (
    <>
      <Heading as="h3" color="blue.500" fontWeight="bold" fontSize="18" mb={4}>
        <FormattedMessage defaultMessage="Awards" id="FqvBgl" />
      </Heading>
      <div css={{ paddingLeft: 10 }}>
        {story.awards.map((award) => (
          <Tag variant="rounded" maxWidth="250px" mr={2} mb={2} key={award._id} title={award.name}>
            <TagText>{award.name}</TagText>
          </Tag>
        ))}
      </div>
    </>
  );
}
